/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {AbstractSearchCriteriaService} from '../../../shared/filter/abstract-search-criteria.service';
import {BusinessSettingsVersionColumnEnum} from '../models/business-settings-version-column.enum';
import {Injectable} from '@angular/core';
import {SortDirection} from '../../../api/generic/contracts/sort-direction.enum';
import {SettingQueryModel} from '../../../api/ms-settings/business/schema/v1/contracts/setting-query.model';
import {SettingStatusEnum} from '../../../api/ms-settings/business/schema/v1/contracts/setting-status.enum';
import {SettingsCriterionEnumEnum} from '../../../api/ms-settings/business/schema/v1/contracts/settings-criterion.enum';

@Injectable({
    providedIn: 'root'
})
export class BusinessSettingsSearchCriteriaService extends AbstractSearchCriteriaService<BusinessSettingsVersionColumnEnum> {
    clear(): void {
        // clear stored filters
        this.stateMap.clear();

        // Sort criteria
        this.sortDirection = SortDirection.DESC;
        this.sortedBy = null;

        // Pagination
        this.pageSize = 10;
        this.pageNumber = 1;
        this.totalResults = 0;
    }

    public getStaticDataQuery(): SettingQueryModel {
        return {
            searchCriteria: {
                settingStatusCodes: [SettingStatusEnum.DRAFT, SettingStatusEnum.ACTIVE]
            },
            paginationCriteria: {
                sortCriteria: [
                    {
                        criterion: SettingsCriterionEnumEnum.STATUS,
                        sortDirection: SortDirection.DESC
                    }
                ],
                firstResult: 0,
                maxResults: 20
            }
        };
    }

    public getDynamicDataQuery(): SettingQueryModel {
        return {
            searchCriteria: {
                settingStatusCodes: [SettingStatusEnum.OLD]
            },
            // TODO: use `this.paginationCriteria` after sorting is implemented
            paginationCriteria: {
                sortCriteria: [],
                firstResult: this.pageSize * (this.pageNumber - 1),
                maxResults: this.pageSize
            }
        };
    }
}
